import * as Yup from "yup";

export const VerificationSchema = Yup.object().shape({
  email: Yup.string()
  .email("E-mail is not valid!")
  .required("E-mail is required!"),
});
